import {
    ChartTooltipLabelShape,
    LabelShape,
} from '@/components/common/charts/ChartTooltip';
import { FlexRow } from '@/components/common/Flex';
import { ChevronRight } from '@/components/common/icons';
import { groupHoverStyleProps } from '@/components/common/styleHelpers';
import { Subheader } from '@/components/common/Typography';
import { SquareProps } from '@chakra-ui/react';

type HeaderLinkProps = {
    onClick: () => void;
    title: string;
    labelColor?: SquareProps['bg'];
    labelShape?: ChartTooltipLabelShape;
};
const HeaderLink = ({
    onClick,
    title,
    labelColor,
    labelShape,
}: HeaderLinkProps) => (
    <FlexRow
        alignItems="center"
        role="group"
        cursor="pointer"
        onClick={onClick}
    >
        {labelColor && labelShape && (
            <LabelShape color={labelColor} shape={labelShape} />
        )}
        <Subheader
            {...groupHoverStyleProps({
                color: 'blue.400',
            })}
        >
            {title}
        </Subheader>
        <ChevronRight
            size="sm"
            ml={1}
            color="gray.500"
            {...groupHoverStyleProps({
                color: 'blue.400',
            })}
        />
    </FlexRow>
);

export default HeaderLink;
